import { render } from "./CategoriesTable.vue?vue&type=template&id=58978381&scoped=true&ts=true"
import script from "./CategoriesTable.vue?vue&type=script&lang=ts"
export * from "./CategoriesTable.vue?vue&type=script&lang=ts"

import "./CategoriesTable.vue?vue&type=style&index=0&id=58978381&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58978381"]])

export default __exports__